import React from 'react';

const streakLines = [
  { y: 18, len: 30, w: 1.4, o: 0.5 },
  { y: 28, len: 42, w: 1.8, o: 0.65 },
  { y: 38, len: 58, w: 2.2, o: 0.8 },
  { y: 48, len: 70, w: 2.6, o: 0.9 },
  { y: 58, len: 78, w: 3, o: 1 },
  { y: 68, len: 70, w: 2.6, o: 0.9 },
  { y: 78, len: 58, w: 2.2, o: 0.8 },
  { y: 88, len: 42, w: 1.8, o: 0.65 },
  { y: 98, len: 30, w: 1.4, o: 0.5 },
];

const ChatBoltSticker = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 120 120"
    width="76"
    height="76"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <clipPath id="hyperspaceClip">
        <circle cx="60" cy="58" r="53" />
      </clipPath>
    </defs>

    {/* deep space patch */}
    <circle cx="60" cy="58" r="56" fill="#05060C" />
    <circle cx="60" cy="58" r="56" fill="none" stroke="#F3ECDE" strokeWidth="3" />

    <g clipPath="url(#hyperspaceClip)">
      {/* hyperspace jump: stars stretched into streaks converging toward a vanishing point ahead */}
      {streakLines.map((s) => (
        <line
          key={s.y}
          x1={112}
          y1={s.y}
          x2={112 - s.len}
          y2={s.y}
          stroke="#DCE6F5"
          strokeWidth={s.w}
          strokeLinecap="round"
          opacity={s.o}
        />
      ))}
      <circle cx="110" cy="58" r="6" fill="#FFFFFF" opacity="0.9" />
      <circle cx="110" cy="58" r="14" fill="#DCE6F5" opacity="0.25" />
    </g>

    {/* small wedge starfighter, silhouette, blasting into the jump */}
    <path
      d="M18 58 L44 48 L39 55 L60 55 L60 61 L39 61 L44 68 Z"
      fill="#F3ECDE"
    />
    <circle cx="19" cy="58" r="2.6" fill="#B3413E" />
  </svg>
);

export default ChatBoltSticker;
